export default __webpack_public_path__ + "static/media/bsc.d24a0a7b.svg";